module.exports = __webpack_public_path__ + "static/media/Modify.b8155bca.svg";